var _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgSignout(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 14.478,
    height: 14.473,
    viewBox: "0 0 14.478 14.473",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Sign_out",
    "data-name": "Sign out",
    transform: "translate(-0.17 -0.16)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "ARROW_48",
    "data-name": "ARROW 48",
    transform: "translate(0.17 0.16)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_39247",
    "data-name": "Path 39247",
    d: "M8.868,9.984a.679.679,0,0,0-.679.679v1.654a.96.96,0,0,1-.959.959H2.486a.96.96,0,0,1-.959-.959V2.477a.96.96,0,0,1,.959-.959H7.231a.96.96,0,0,1,.959.959v1.43a.679.679,0,1,0,1.358,0V2.477A2.319,2.319,0,0,0,7.231.16H2.486A2.319,2.319,0,0,0,.17,2.477v9.84a2.319,2.319,0,0,0,2.316,2.317H7.231a2.319,2.319,0,0,0,2.316-2.317V10.663A.679.679,0,0,0,8.868,9.984Z",
    transform: "translate(-0.17 -0.16)",
    fill: "#1a1818"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Path_39248",
    "data-name": "Path 39248",
    d: "M206.949,148.766l-2.416-2.414a.679.679,0,0,0-.95-.009.691.691,0,0,0,0,.98l1.258,1.259h-5.883a.679.679,0,1,0,0,1.358h5.883l-1.27,1.27a.679.679,0,1,0,.96.96l2.417-2.416a.7.7,0,0,0,0-.987Z",
    transform: "translate(-192.676 -142.023)",
    fill: "#1a1818"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgSignout);
export default __webpack_public_path__ + "static/media/Signout.4d3c5044731684e9fe1aaa6fc65e5357.svg";
export { ForwardRef as ReactComponent };